import React, {
  ComponentType,
  createContext,
  JSXElementConstructor,
  ReactElement,
} from 'react';

import { ElevateTheme, Theme } from '@wds/styles';
import { createTheming, ThemeProvider } from 'react-jss';
import { ThemeName } from '../types';
import { HeaderTheme } from './theme';
import { ElevateHeaderTheme } from './themes';

const HeaderThemeMapper: Record<ThemeName, HeaderTheme> = {
  elevate: ElevateHeaderTheme,
};

const ThemeMapper: Record<ThemeName, Theme> = {
  elevate: ElevateTheme,
};

type ThemeProps = {
  theme?: ThemeName;
};

const ThemeContext = createContext<HeaderTheme>(ElevateHeaderTheme);
const theming = createTheming(ThemeContext);
const {
  ThemeProvider: HeaderThemeProvider,
  useTheme: useHeaderTheme,
} = theming;

const withHeaderTheme = <T extends object>(
  Component: ComponentType<T>
): JSXElementConstructor<T & ThemeProps> => ({
  theme,
  ...rest
}: ThemeProps): ReactElement<T & ThemeProps> => (
  <ThemeProvider theme={ThemeMapper.elevate}>
    <HeaderThemeProvider theme={HeaderThemeMapper.elevate}>
      <Component {...(rest as T)} />
    </HeaderThemeProvider>
  </ThemeProvider>
);

export { HeaderThemeProvider, useHeaderTheme, withHeaderTheme };

export type { HeaderTheme, ThemeProps };
